module.exports = __webpack_public_path__ + "media/images/icon_btn_delete-83f2ee9af1a2e5d6b168750c0afa3d9e.png";